import React from 'react';

import { Suspense } from '@lumapps/lumx-suspense/components/Suspense';
import { useSelector } from '@lumapps/redux/react';

import { getFrontOfficeSelector } from '../../ducks/selectors';

const NannyDetailsModal = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'nanny-details-modal' */
            './ConnectedDetailModal'
        ),
);

export const NannyDetails = () => {
    const { isAlertDisplayed } = useSelector(getFrontOfficeSelector);

    return isAlertDisplayed ? (
        <Suspense isDialog>
            <NannyDetailsModal />
        </Suspense>
    ) : null;
};
